import React, { Component } from "react";
import { connect } from "react-redux";
import {
    updateSelectCard,
    updateAreaList,
    updateSelectArea,
    clearData,
    setTabLayModalVisible,
    setZoneDataFun,
} from "Store/ZoneSetting/action";
import { clearZoneData } from 'Store/Zone/action';
import Ajax from "Pub/js/ajax";
import "./index.less";
import withDragDropContext from "Pub/js/withDragDropContext";
import AreaItem from "./areaItem";
import TreeModal from "./treeModal";
import _ from "lodash";
import Notice from "Components/Notice";
import { DropTarget } from 'react-dnd';
import { langCheck } from 'Pub/js/utils';
import { addNewAreaItem, getFormHeadCode } from './events';
import emptycontentImg from "Assets/images/template-empty-content.png";
import platform from "Pub/js/platform";
import TabLaySetModal from "./components/TabLaySetModal";
import { addMetaItem, filterRepeatMeta, giveRepeatedTips } from './methods/addMetaItem';
// 导入元数据树数据模型相关的操作方法
import { queryMetaTreeData, createMetaTreeIns } from './metatree/MetaTreeTools';
import MetaTreeModel from './metatree/MetaTreeModel';
import update from 'immutability-helper';
const { NCDiv } = platform.base;
//内容组件类

const areaTarget = {
    // hover(props, monitor, component) {
    //     const dragItem = monitor.getItem();

    // },
    drop(props, monitor, component) {
        const dragItem = monitor.getItem();
        if (!dragItem.type) {return;}
        //拖拽的是区域不是孙表
        if (dragItem.type === 'area' && dragItem.areaType !== 'grandson') {
            addNewAreaItem(props, {
                items: { areatype: dragItem.areaCode },
                isExpand: true,
            });
        }
    },
    canDrop(props, monitor) {
        const dropItem = monitor.getItem();
        return dropItem.type !== 'card';
    },
};

//DropTarget用于包装接收拖拽元素的组件，使组件能够放置
@DropTarget('area', areaTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
}))
class MyContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false,
            metaTree: [],
            origTree: null,
            curTree: null,
            targetAreaID: "",
            targetAreaType: "",
            canSelectTreeNodeList: [],
        };
    }
    componentWillUnmount() {
        this.props.clearData();
        this.props.clearZoneData();
    }
    componentDidMount() {
    }
    //设置元数据树模态框是否可见
    setModalVisible = modalVisible => {
        this.setState({ modalVisible });
    };
    /**
     * 打开元数据树的模态框
     * @param {String} metaid
     * @param {String} targetAreaID 目标区域ID
     * @param {String} areatype 区域类型
     */
    addMetaInArea = (metaid, targetAreaID, areatype) => {
        let { json } = this.props;
        if (metaid === '' || metaid === null || metaid === undefined) {
            Notice({ status: "warning", msg: langCheck('ZoneSetting-000019', 'pages', json) });/* 国际化处理： 请关联元数据*/
            return;
        }
        queryMetaTreeData.call(this, metaid, '').then(data => {
            if (data && data.length > 0) {
                let treeData = { isleaf: false, readonly: false, refpk: metaid, refcode: '', pid: null, children: data };
                let tree = createMetaTreeIns.call(this, treeData, areatype);
                let serializeTree = MetaTreeModel.serialize(tree);
                let allNodes = serializeTree.nodes;
                //数据类型205的，即可以全选该节点下面的叶子节点，需要模态框中显示select进行选择
                let canSelectTreeNodeList = [];
                let metaTreeRootData = tree.getMetaTreeData();
                let metaTree = metaTreeRootData.children;
                allNodes.forEach(m => {
                    if (m.data.datatype === '205') {
                        canSelectTreeNodeList.push(m.data);
                    }
                });

                this.setState({
                    origTree: tree,
                    curTree: tree,
                    metaTree,
                    targetAreaID,
                    targetAreaType: areatype,
                    canSelectTreeNodeList,
                });
                this.setModalVisible(true);
            } else {
                Notice({ status: "warning", msg: langCheck('ZoneSetting-000021', 'pages', json) });/* 国际化处理： 元数据树为空*/
            }
        });
    }
    //更新元数据树的数据
    updateMetaTreeData = metaTree => {
        this.setState({ metaTree: metaTree });
    };
    // 更新元数据树实例
    updateMetaTree = (origTree, curTree) => {
        this.setState({ origTree, curTree });
    }
    //添加卡片
    addCard = addCardList => {
        let { targetAreaID } = this.state;
        let { areaList } = this.props;
        areaList = _.cloneDeep(areaList);
        let targetAreaIndex = -1;
        let metaid = "";
        //从areaList中确定目标区域
        _.forEach(areaList, (a, i) => {
            if (targetAreaID === a.pk_area) {
                targetAreaIndex = i;
                metaid = a.metaid;
                return false;
            }
        });
        //以code为主键，去重
        areaList[targetAreaIndex].queryPropertyList = _.uniqBy(
            areaList[targetAreaIndex].queryPropertyList.concat(addCardList),
            "code",
        );
        //初始化卡片position和classid属性
        _.forEach(areaList[targetAreaIndex].queryPropertyList, (q, i) => {
            q.position = i + 1;
            q.classid = metaid;
        });
        this.props.updateAreaList(areaList);
    };

    addCardFromMetaTree = ({ cardList, targetAreaID, dropIndex }) => {
        let { areaList, json } = this.props;
        areaList = _.cloneDeep(areaList);
        let targetAreaIndex,
            metaid;

        _.forEach(areaList, (a, i) => {
            if (targetAreaID === a.pk_area) {
                targetAreaIndex = i;
                metaid = a.metaid;
                return false;
            }
        });

        let { queryPropertyList } = areaList[targetAreaIndex];
        let result = filterRepeatMeta(queryPropertyList, cardList);

        if (Object.keys(result.errorMsg).length > 0) {
            giveRepeatedTips(result.errorMsg, json);
        }

        if (result.cardList.length > 0) {
            //更改数组显示顺序
            queryPropertyList.splice(dropIndex, 0, ...result.cardList);
            queryPropertyList = _.uniqBy(
                queryPropertyList,
                'code',
            );

            //初始化卡片position和classid属性
            _.forEach(queryPropertyList, (q, i) => {
                q.position = i + 1;
                q.classid = metaid;
            });

            this.props.updateAreaList(areaList);
        }
    };

    /**
     * 移动卡片
     * @param {Number} dragIndex 拖拽卡片的index
     * @param {Number} hoverIndex 目标卡片的index
     * @param {Number} areaItemIndex 目标区域的index
     **/
    //如果需要跨区域移动卡片再放开
    // moveCard = (dragIndex, hoverIndex, areaItemIndex) => {
    //     let { areaList } = this.props;
    //     areaList = _.cloneDeep(areaList);
    //     const cards = areaList[areaItemIndex].queryPropertyList;

    //     const dragCard = cards[dragIndex];
    //     cards.splice(dragIndex, 1);
    //     cards.splice(hoverIndex, 0, dragCard);
    //     _.forEach(cards, (q, i) => {
    //         q.position = i + 1;
    //     });
    //     this.props.updateAreaList(areaList);
    //     // this.props.updateSelectCard({}); //出于性能考虑注掉
    // };
    /**
     * 删除卡片
     * @param {Number} cardIndex 目标卡片index
     * @param {Number} areaItemIndex 目标区域的index
     **/
    deleteCard = (cardIndex, areaItemIndex) => {
        let { areaList } = this.props;
        areaList = _.cloneDeep(areaList);

        const cards = areaList[areaItemIndex].queryPropertyList;

        cards.splice(cardIndex, 1);

        this.props.updateAreaList(areaList);
        this.props.updateSelectCard({});
    };

    /**
     * 增加元数据
     */
    addMetaItem = ({ selectedTreeNode, targetAreaID, dataRef, dropIndex }) => {
        let { json, newAreaList, areaList } = this.props;
        addMetaItem.call(this, {
            selectedTreeNode,
            targetAreaID,
            dataRef,
            json,
            areaList,
            dropIndex,
        });
    };
    /**
     * 选择卡片
     * @param {Number} cardIndex 目标卡片index
     * @param {Number} areaItemIndex 目标区域的index
     **/
    //改为写在card里，这里就没用了
    // selectThisCard = (cardIndex, areaItemIndex) => {
    //     let { areaList } = this.props;
    //     let card = areaList[areaItemIndex].queryPropertyList[cardIndex];
    //     this.props.updateSelectCard(card);
    // };

    /**
     * 移动区域的顺序
     * @param {Number} dragIndex 拖拽的组对象的index值
     * @param {Number} hoverIndex 拖拽中鼠标悬浮的组对象的index值
    **/
    dragAreaItem = (dragIndex, hoverIndex) => {
        let { areaList } = this.props;
        areaList = _.cloneDeep(areaList);
        const dragItem = areaList[dragIndex];
        areaList.splice(dragIndex, 1);
        areaList.splice(hoverIndex, 0, dragItem);
        this.props.updateAreaList(areaList);
    };

    //上移
    moveUp = (areaList, areaIndex) => {
        let targetIndex = areaIndex - 1;
        if (this.props.newAreaList[targetIndex] === null) {
            //找到下一个不是null的areaItem
            let tempArr = areaList.slice(0, targetIndex);
            targetIndex = _.findLastIndex(tempArr, item => item !== null) - 1;
        }
        return this.swapAreaItem(areaList, areaIndex, targetIndex);
    }

    //下移
    moveDown = (areaList, areaIndex) => {
        let targetIndex = areaIndex + 1;
        if (this.props.newAreaList[targetIndex] === null) {
            //找到下一个不是null的areaItem
            targetIndex = areaList.slice(targetIndex).findIndex(item => item !== null) + targetIndex + 1;
        }
        return this.swapAreaItem(areaList, areaIndex, targetIndex);
    }

    //移动区域
    moveArea = (moveType, areaList, areaIndex) => {
        const currArea = areaList[areaIndex]; //移动的区域
        const headCode = getFormHeadCode(areaList, this.props.zoneFormData.headcode);
        let targetIndex;
        if (moveType === 'up') { //上移
            targetIndex = areaIndex - 1;
            //上移的区域关联的是主表
            if (areaList[targetIndex].relationcode === headCode) {
                let headIndex = areaList.findIndex(item => item.code === headCode); //主表的index
                this.moveFormGroup('down', areaList, headIndex);
            } else {
                this.moveUp(areaList, areaIndex);
            }
        } else if (moveType === 'down') { //下移
            targetIndex = areaIndex + 1;
            //下移的区域是主表
            if (areaList[targetIndex].code === headCode) {
                this.moveFormGroup('up', areaList, targetIndex);
            } else {
                this.moveDown(areaList, areaIndex);
            }
        }

    }
    /**
     * 区域上移/下移
     *  @param type 移动类型 上移/下移
     *  @param areaIndex 区域index
     *
     */
    moveAreaItem = (type, areaIndex) => {
        let areaList = _.cloneDeep(this.props.areaList);
        const currArea = areaList[areaIndex]; //移动的区域
        const headCode = getFormHeadCode(areaList, this.props.zoneFormData.headcode);
        if (type === 'up' && areaIndex === 0) {return;} //上移到第一个
        if (type === 'down' && areaIndex === areaList.length - 1) {return;} //下移到最后一个
        //移动的是主表
        if (currArea.code === headCode) {
            this.moveFormGroup(type, areaList, areaIndex);
        } else {
            this.moveArea(type, areaList, areaIndex);
        }
        this.props.updateAreaList(areaList);
    }

    /**
     * 移动主表位置
     *
     *  @param moveType 移动类型 up:上移 down:下移
     *  @param areaList 区域数据
     *  @param areaIndex 当前区域index
     */
    moveFormGroup = (moveType, areaList, areaIndex) => {
        const formGroupList = this.getFormGroupList(areaList);
        if (moveType === 'up') {
            let itemIndex = areaIndex - 1;
            this.insertAreaItem(areaList, areaIndex + formGroupList.length, itemIndex);
        } else if (moveType === 'down') {
            let itemIndex = areaIndex + formGroupList.length + 1;
            this.insertAreaItem(areaList, areaIndex, itemIndex);
        }
    }

    /**
     * 交换区域位置
     *
     *  @param areaList 区域数据
     *  @param targetIndex 目标index
     *  @param sourceIndex 来源index
     */
    swapAreaItem = (areaList, sourceIndex, targetIndex) => {
        return [areaList[sourceIndex], areaList[targetIndex]] = [areaList[targetIndex], areaList[sourceIndex]];
    }

    /**
     * 将区域插入到指定位置
     *
     *  @param areaList 区域数据
     *  @param targetIndex 插入的目标index
     *  @param itemIndex 元素的index
     */
    insertAreaItem = (areaList, targetIndex, itemIndex) => {
        let targetArea = areaList.splice(itemIndex, 1)[0];
        areaList.splice(targetIndex, 0, targetArea);
    }
    /**
     * 分组上移/下移
     *  @param type 移动类型 上移/下移
     *  @param areaIndex 分组对应的区域index
     *
     */
    moveFormGroupItem = (type, areaIndex) => {
        const { areaList } = this.props;
        const headCode = getFormHeadCode(areaList, this.props.zoneFormData.headcode);
        const prevGroupIndex = _.findLastIndex(areaList, item => item.relationcode === headCode && item.areatype === '1', areaIndex - 1); //上一个分组
        const nextGroupIndex = _.findIndex(areaList, item => item.relationcode === headCode && item.areatype === '1', areaIndex); //下一个分组
        this.moveChildrenItem(type, areaIndex, prevGroupIndex, nextGroupIndex);
    }

    /**
    * 孙表上移/下移
    *  @param type 移动类型 上移/下移
    *  @param areaIndex 分组对应的区域index
    *  @param grandson 孙表区域数据
    *
    */
    moveGrandsonItem = (type, areaIndex, grandson) => {
        const { areaList } = this.props;
        const prevGrandsonIndex = _.findLastIndex(areaList, item => item.relationcode === grandson.relationcode && item.isgrandson === true, areaIndex - 1); //上一个孙表
        const nextGrandsonIndex = _.findIndex(areaList, item => item.relationcode === grandson.relationcode && item.isgrandson === true, areaIndex); //下一个孙表
        this.moveChildrenItem(type, areaIndex, prevGrandsonIndex, nextGrandsonIndex);
    }

    //子区域（分组/孙表）上移/下移
    moveChildrenItem = (type, areaIndex, prevChildIndex, nextChildIndex) => {
        let areaList = _.cloneDeep(this.props.areaList);
        //上移
        if (type === 'up') {
            let targetindex = prevChildIndex < 0 ? 0 : prevChildIndex;
            this.insertAreaItem(areaList, targetindex, areaIndex);
        }
        //下移
        if (type === 'down') {
            this.insertAreaItem(areaList, nextChildIndex + 1, areaIndex);
        }
        this.props.updateAreaList(areaList);
    }
    /**
     * 删除区域
     * @param {String} areaID 目标分组id
    **/
    deleteAreaItem = (areaID, callback) => {
        let areaList = _.cloneDeep(this.props.areaList);
        _.remove(areaList, item => item.pk_area === areaID);
        //如果删除的区域，是设置表头的区域，则将设置表头值置空
        let { zoneFormData } = this.props;
        let { headcode } = zoneFormData;
        let target = areaList.find(item => item.code === headcode);
        console.log(target);
        if (!target) {
            zoneFormData = update(zoneFormData, { headcode: { $set: '' } });
            this.props.setZoneDataFun(zoneFormData);
        }
        this.props.updateAreaList(areaList);
        callback && callback();
    };

    /**
     * 展开/收起区域
     *
     * index - 区域index
     * flag - 展开(true)收起(false)状态
     */
    expandArea = (index, flag) => {
        let areaList = _.cloneDeep(this.props.areaList);
        areaList[index].isShow = flag;
        areaList.forEach(el => {
            //展开多页签
            if (el.associatedtab && el.associatedtab === areaList[index].code) {
                el.isShow = flag;
            }
        });
        this.props.updateAreaList(areaList);
    }

    //得到主表分组数据
    getFormGroupList = areaList => {
        let result = [...areaList];
        const relationList = result.filter(item => item.relationcode); //有关联区域的区域
        let headCode = getFormHeadCode(result, this.props.zoneFormData.headcode);
        result = relationList.filter(r => r.relationcode === headCode);
        return result;
    }

    //切换表格区视图
    handleToggleTableView = (index, flag) => {
        let areaList = _.cloneDeep(this.props.areaList);
        areaList[index] = { ...areaList[index], ...{ isTile: flag } };//表格区是否平铺
        this.props.updateAreaList(areaList);
    }

    render() {
        let { json, canDrop, connectDropTarget, areaList, newAreaList, templetid, showTabLaySetModal, multiOptions } = this.props;
        let backgroundColor = '#f0f2f5';
        console.log({ newAreaList });
        //如果需要拖拽背景色再放开
        if (canDrop) {
            backgroundColor = 'rgba(221, 236, 250, 0.3)';
        }

        return connectDropTarget(
            <div
                type="ncdiv"
                fieldid="middle_area"
                className="template-setting-content"
                style={{ backgroundColor }}
            >
                {
                    this.props.isImplement &&
                    <div
                        className='content-area-template-name'
                    >
                        {this.props.zoneFormData.name}
                    </div>
                }

                {
                    newAreaList.length > 0 ?
                        newAreaList.map((a, i) => {
                            if (a) {
                                return (
                                    <AreaItem
                                        areaItem={a}
                                        key={i}
                                        areaListLength={newAreaList.length}
                                        id={a.pk_area}
                                        index={i}
                                        areatype={a.areatype}
                                        metaid={a.metaid}
                                        isShow={a.isShow}
                                        // moveCard={this.moveCard}
                                        deleteCard={this.deleteCard}
                                        addMetaInArea={this.addMetaInArea}
                                        // selectThisCard={this.selectThisCard}
                                        onDragArea={this.dragAreaItem}
                                        onMoveArea={this.moveAreaItem}
                                        onMoveFormGroup={this.moveFormGroupItem}
                                        onMoveGrandson={this.moveGrandsonItem}
                                        onDeleteArea={this.deleteAreaItem}
                                        onExpandArea={this.expandArea}
                                        onToggleTableView={this.handleToggleTableView}
                                        json={json}
                                        pageStatus={this.props.status}
                                        addMetaItem={this.addMetaItem}
                                        pcode={this.props.pcode}
                                        appcode={this.props.appcode}
                                        templetid={templetid}
                                        multiOptions={multiOptions}
                                    />
                                );
                            }
                        })
                        :
                        <div className="empty-content">
                            {
                                //修改不显示占位图
                                !templetid &&
                                <div>
                                    <img src={emptycontentImg} />
                                    {/* 国际化处理：请将左侧区域内容拖拽至此 */}
                                    <p>{langCheck('ZoneSetting-000199', 'pages', json)}</p>
                                    {/* 国际化处理：可自定义查询区、列表区等 */}
                                    <p>{langCheck('ZoneSetting-000201', 'pages', json)}</p>
                                </div>
                            }
                        </div>
                }

                {/* 元数据树模态框 */}
                <TreeModal
                    origTree={this.state.origTree}
                    curTree={this.state.curTree}
                    metaTree={this.state.metaTree}
                    canSelectTreeNodeList={this.state.canSelectTreeNodeList}
                    modalVisible={this.state.modalVisible}
                    targetAreaID={this.state.targetAreaID}
                    targetAreaType={this.state.targetAreaType}
                    targetAreaCardLength={this.state.targetAreaCardLength}
                    setModalVisible={this.setModalVisible}
                    addCard={this.addCard}
                    updateMetaTreeData={this.updateMetaTreeData}
                    json={this.props.json}
                    updateMetaTree={this.updateMetaTree}
                    areaList={areaList}
                />
                {
                    showTabLaySetModal && <TabLaySetModal
                        json={json}
                        visible={showTabLaySetModal}
                        multiOptions={this.props.multiOptions}

                    />
                }
            </div>,
        );
    }
}
export default connect(
    state => ({
        areaList: state.zoneSettingData.areaList,
        newAreaList: state.zoneSettingData.newAreaList,
        zoneFormData: state.zoneSettingData.zoneFormData,
        isImplement: state.zoneSettingData.isImplement,
        showTabLaySetModal: state.zoneSettingData.showTabLaySetModal,
    }),
    {
        clearData,
        clearZoneData,
        updateAreaList,
        updateSelectArea,
        updateSelectCard,
        setTabLayModalVisible,
        setZoneDataFun,
    },
)(withDragDropContext(MyContent));
